export default "__VITE_ASSET__CMzFvfg6__"